<div class="each-section flex flex-col" *ngIf="true">
    <header class="flex flex-row justify-between items-center" *ngIf="true">
        <div class="title hide">
            {{section?.title}}
        </div>
        <div class="right-section m-r-9">
            <button mat-icon-button [matMenuTriggerFor]="actionMenu" class="">
                <mat-icon class="s-20">more_horiz</mat-icon>
            </button>
            <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
                <!--<button *ngIf="!isManageFields" mat-menu-item class="" (click)="addNewItem(false)"><span>Add Question</span>
                </button>-->
                <button mat-menu-item class="" (click)="addNewItem(isManageFields)"><span>Add Field</span>
                </button>
                <button *ngIf="canAddExternalField" mat-menu-item class="" (click)="addExternalNewItem()"><span>Add External Field</span>
                </button>
                <button mat-menu-item class="" (click)="addSection();$event.stopPropagation();">
                    <span>Add Section</span>
                </button>
                <!--<button  mat-menu-item class=""  (click)="editDetailsAndInstruction();$event.stopPropagation();">
                  <span>Details & Instructions</span>
                </button>-->
                <button mat-menu-item class="" *ngIf="section.isCustom"
                        (click)="renameSection();$event.stopPropagation();">
                    <span>Rename Section</span>
                </button>
                <button mat-menu-item class="" *ngIf="section.isCustom && totalSections >1"
                        (click)="deleteSection();$event.stopPropagation();">
                    <span>Delete Section</span>
                </button>
            </mat-menu>
        </div>
    </header>
    <div class="details">
        <particle-flow-chart-designer #flowChartDesigner [section]="section"
                                      [flowChartDataService]="flowChartDataService"
                                      [sourceType]="sourceType"
                                      [flowchart]="flowchart"
        ></particle-flow-chart-designer>
    </div>
</div>

